<template>
  <transition name="wechat-qr-fade">
    <div v-if="visible" class="wechat-qr-overlay" @click.self="close">
      <div class="wechat-qr-dialog">
        <button class="wechat-qr-close" type="button" @click="close">x</button>
        <QrCard />
      </div>
    </div>
  </transition>
</template>

<script>
import QrCard from '@/components/qr-card.vue';

export default {
  name: 'WechatQrModal',
  components: {
    QrCard,
  },
  data() {
    return {
      visible: false,
    }
  },
  mounted() {
    window.addEventListener('open-wechat-qr', this.open);
  },
  beforeDestroy() {
    window.removeEventListener('open-wechat-qr', this.open);
  },
  methods: {
    open() {
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
  },
}
</script>

<style scoped>
.wechat-qr-overlay {
  position: fixed;
  inset: 0;
  z-index: 1000000000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(17, 24, 39, 0.46);
}

.wechat-qr-dialog {
  position: relative;
}

.wechat-qr-close {
  position: absolute;
  top: -12px;
  right: -12px;
  z-index: 1;
  width: 28px;
  height: 28px;
  border: 0;
  border-radius: 50%;
  background: #173b3a;
  color: #fff;
  font-size: 16px;
  line-height: 28px;
  cursor: pointer;
}

.wechat-qr-fade-enter-active,
.wechat-qr-fade-leave-active {
  transition: opacity 0.18s ease;
}

.wechat-qr-fade-enter,
.wechat-qr-fade-leave-to {
  opacity: 0;
}
</style>
